<template>
  <SimpleDataTable
      :title="'Gider Raporu'"
      :description="''"
      :dataList="expenseData"
      :dataHeaders="expenseDataHeaders"
      :loading="expenseDataLoading"
      :per-page="perPage"
      :pagination-status="true"
      :pagination-length="maxPage"
      @page-change="handlePageChange"
      :error-message="errorMessage"
  >
    <template v-slot:filterAndAction>

      <v-select
          v-model="timePeriodFilterValue"
          :items="[
                      {value: 5, text: 'Tarih Aralığı'},
                      {value: 4, text: 'Yıllık'},
                      {value: 3, text: 'Aylık'},
                      {value: 2, text: 'Haftalık'},
                      {value: 1, text: 'Günlük'}
                  ]"
          style="max-width:250px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          solo
          hide-details
          dense
          @change="timePeriodFilterValue !== 5  ? _fetchExpenseList : null"
      >

      </v-select>
      <div v-if="timePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(dateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                clearable
                @click:clear="dateRangeStartFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRangeStartFilterValue"
              locale="tr"
              :max="dateRangeEndFilterValue ? dateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(dateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="dateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateRangeEndFilterValue"
              locale="tr"
              :min="dateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchExpenseList"
          >
            FİLTRELE
          </v-btn>
        </div>

      </div>
    </template>
    <template v-if="expenseData.length > 0" v-slot:tableFooter>
      <tr>
        <td></td>
        <td></td>
        <td class="text-right"> <hr> <b>Toplam : </b>
          <b>{{ numberConverter(expenseAmount) }}</b></td>
      </tr>
    </template>
    <template v-else v-slot:tableFooter>
      <tr>
        <td class="text-right"><b>Toplam : </b> <b>{{ numberConverter(expenseAmount) }}</b></td>
      </tr>
    </template>
    <template v-slot:perPage>
      <p class="text-start m-0">Gösterilen Kayıt Sayısı</p>
      <v-btn-toggle class="my-4" mandatory solo dense>
        <v-btn @click="perPage = 10"> 10</v-btn>
        <v-btn @click="perPage = 20"> 20</v-btn>
        <v-btn @click="perPage = 30"> 30</v-btn>
        <v-btn @click="perPage = 50"> 50</v-btn>
        <v-btn @click="perPage = 100"> 100</v-btn>
      </v-btn-toggle>
    </template>

    <!--    <template v-slot:pagination>-->
    <!--      <div class="row">-->
    <!--        <div class="col-lg-12 mb-5">-->
    <!--          <v-pagination-->
    <!--              v-model="currentPage"-->
    <!--              circle-->
    <!--              class="my-4"-->
    <!--              :length="1"-->
    <!--              :total-visible="8"-->
    <!--          ></v-pagination>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </template>-->
  </SimpleDataTable>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../../helpers";
import {mapActions, mapState} from "vuex"

export default {
  name: "GiderRaporu",
  components: {
    SimpleDataTable
  },
  props: {
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  mounted() {
    this._fetchExpenseList()
  },
  data() {
    return {
      maxPage: null,
      expenseDataHeaders: [],
      expenseData: [],
      expenseDataLoading: false,
      timePeriodFilterValue: 4,
      dateRangeStartFilterValue: null,
      dateRangeEndFilterValue: null,
      currentPage: 1,
      perPage: 10,
      expenseAmount: 0,
      errorMessage: "",
    }
  },
  methods: {
    ...mapActions("dashboard", ["fetchExpenseList", "fetchExpenseListTotal"]),
    formattedDate,
    numberConverter,
    async handlePageChange(newPage) {
      this.currentPage = newPage;
      await this._fetchBorrowerCurrentList();
    },
    _fetchExpenseList() {

      this.expenseDataLoading = true;

      const requestData = {
        params: {
          pageNumber: this.currentPage,
          pageSize: this.perPage
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp},
          ...(!(this.timePeriodFilterValue === "" || this.timePeriodFilterValue == null)) && {DateType: this.timePeriodFilterValue},
        }
      };

      if (this.timePeriodFilterValue === 5) {
        requestData.body.startDate = this.dateRangeStartFilterValue;
        requestData.body.endDate = this.dateRangeEndFilterValue;
      }

      this._fetchExpenseListTotal(requestData);


      this.fetchExpenseList(requestData).then((result) => {
        if (result && result.data.success) {
          this.expenseData = result.data.data;
          this.expenseData.map(item => item.amount = this.numberConverter(item.amount))
          this.expenseDataHeaders = [
            {
              key: 'accountCode',
              label: 'Hesap Kodu',
              sortable: false,
            },
            {
              key: 'accountName',
              label: 'Hesap Adı',
              sortable: false,
            },
            {
              class:'text-right',
              key: 'amount',
              label: 'Tutar',
              sortable: false,
            },
          ]
          this.maxPage = result.data.totalPages;

        } else {
          this.errorMessage = result.data.message;
          this.expenseData = [];
        }
        this.expenseDataLoading = false;
      })
    },
    _fetchExpenseListTotal(item) {

      this.expenseDataLoading = true;
      this.fetchExpenseListTotal(item).then((result) => {
        if (result.data.success) {
          this.expenseAmount = result.data.data.amount
        } else
          this.expenseAmount = 0;

        this.expenseDataLoading = false;
      })
    },
  },
  watch: {
    perPage: function (newVal) {
      newVal;
      this.currentPage = 1;
      this._fetchExpenseList()
    },
    currentPage: function (newVal) {
      newVal;
      this._fetchExpenseList();
    },
    dashboardFilterCurrentCodeProp(newVal) {
      newVal;
      this._fetchExpenseList()
    },
    dashboardFilterSalesPersonCodeProp(newVal) {
      newVal;
      this._fetchExpenseList()
    },
    dashboardFilterReportDbNameProp(newVal) {
      newVal;
      this._fetchExpenseList()
    },
    timePeriodFilterValue(newVal) {
      newVal;
      if (newVal === 5) return;
      this._fetchExpenseList()
    },
  }

}
</script>

<style scoped>

</style>